// extracted by mini-css-extract-plugin
module.exports = {"modalFooterButtons":"OrderStatusEditionModal_modalFooterButtons__1dPCJ"};